// Ciro kaydinin is turu ve proje no / teknopark birimi gosterimi.
//
// Ibrahim (2026-10-26): ciro onayda is turu cogu satirda gorunmuyordu
// (teknopark, ar-ge merkezi...); teknoparkta proje no yerinde teknopark
// birimi gorunuyordu, burada da gorunsun.
//
// Neden bos kaliyordu: SATIS cirosu isee degil SOZLESMEYE bagli, row.job
// null. Is turu ve numara bu durumda sozlesmenin islerinden okunuyor.
import { jobTypeName } from './jobType';
import { revenueProjectNumber } from './revenueProjectNumber';

const kayitIsleri = (row) => {
  if (row?.job) return [row.job];
  return Array.isArray(row?.contract?.jobs) ? row.contract.jobs : [];
};

const tekil = (list) => [...new Set(list.filter(Boolean))];

/** Is tur adlari (ham). Birden fazla farkli tur varsa hepsi. */
export const revenueJobTypeNames = (row) =>
  tekil(kayitIsleri(row).map((j) => jobTypeName(j)));

const teknoparkMi = (job) => String(jobTypeName(job) || '').toUpperCase() === 'TEKNOPARK';

/**
 * Proje no sutunu: TEKNOPARK islerde teknopark birimi, digerlerinde proje no.
 * Hem yazim/onay sonrasi (tek is) hem satis (sozlesmenin isleri) icin.
 */
export const revenueProjectNoOrUnit = (row) => {
  const isler = kayitIsleri(row);
  const tp = isler.filter(teknoparkMi);
  if (tp.length > 0) {
    const birimler = tekil(tp.map((j) => (j?.teknopark_unit == null ? '' : String(j.teknopark_unit).trim())));
    if (birimler.length) return birimler.join(', ');
  }
  return revenueProjectNumber(row);
};
